import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../common/app_constant";
import { SUB_DIRECTORY } from "../../../../common/constant";
import ErrorLabel from '../../../../component/error_label';
import { actionForgotPassword, resetForgotPasswordResponse } from "../store";


const ForgotPassword = ({ authenticate }) => {

    const navigation = useNavigate()
    const dispatch = useDispatch()

    const {
        register,
        formState: { errors },
        handleSubmit,
    } = useForm({
        defaultValues: {
            email: ""
        },
    });

    const [linkEmail, setLinkEmail] = useState('')

    const { forgotPassword } = useSelector((state) => ({
        ...state.publicStore
    }))

    useEffect(() => {
        if (forgotPassword !== null) {
            dispatch(resetForgotPasswordResponse())
            if (forgotPassword.result === true) {
                setLinkEmail(forgotPassword.response.email)
                // toast.success(forgotPassword.message, {
                //     duration: TOAST_DURATION,
                //     position: TOAST_POSITION,
                //     style: {
                //         color: TOAST_SUCCESS_COLOR
                //     }
                // })
            } else {
                switch (forgotPassword.status_code) {
                    default:
                        toast.error(forgotPassword.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                }
            }
        }
    }, [forgotPassword])

    const onSubmit = async (data) => {
        dispatch(actionForgotPassword({
            email: data.email
        }))
    };

    return (
        <div className="cover">
            <section>
                <div className="mt-5">
                    <div className="container-xxl container-fluid">
                        <div className="row d-flex justify-content-center align-items-center py-5">
                            <div className="col-md-9 col-lg-6">
                                <h1 class="">
                                    Track your policies <br />
                                    <span class="fw-bold">hassle-free</span>
                                </h1>
                                <p class="mt-3">
                                    Automate your day-to-day insurance administration processes with PINC’s admin dashboard.  Keep a track of your on-going and expired policies. The dashboard offers a set of tools like Policy wallet to record any kind of insurance, Renewal reminders, Claim intimations, Active & Inactive policy hub, Company profile and Service support.
                                </p>
                                <div className="d-flex my-4">
                                    <div className="col-6 d-flex">
                                        <div className="w-50">
                                            <img
                                                src={`${SUB_DIRECTORY}/assets/images/1041916.png`}
                                                className="w-75"
                                                alt=""
                                            />
                                        </div>
                                        <div className="my-auto w-100">
                                            <b>Get Claim</b>
                                            <p className="mb-0">Assistance</p>
                                        </div>
                                    </div>
                                    <div className="col-6 d-flex">
                                        <div className="w-50">
                                            <img
                                                src={`${SUB_DIRECTORY}/assets/images/1041887.png`}
                                                className="w-75"
                                                alt=""
                                            />
                                        </div>
                                        <div className="my-auto w-100">
                                            <b>Explore</b>
                                            <p className="mb-0">Policies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 col-lg-5 offset-lg-1">
                                <div className="card shadow">
                                    <div className="card-body">
                                        <form
                                            noValidate
                                            autoComplete="off"
                                            onSubmit={handleSubmit(
                                                onSubmit
                                            )}
                                        >
                                            <div className="align-items-center justify-content-center justify-content-lg-start mb-3">
                                                <p className="lead fw-bold mb-1 me-3 text-secondary">Forgot Password</p>
                                                {
                                                    linkEmail != null && linkEmail != '' ?
                                                        <span className="text-secondary">
                                                            We will send you link to your registered email id  <b>{linkEmail}</b>
                                                        </span>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                            {/* OTP input */}
                                            <div className="form-outline mb-3">
                                                <label className="form-label" htmlFor="email">
                                                    Email ID
                                                </label>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    className="form-control form-control-lg"
                                                    placeholder="Enter registered email id"
                                                    {...register(
                                                        "email",
                                                        {
                                                            required: "This is required.",
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                message: "invalid email address"
                                                            }
                                                        }
                                                    )}
                                                />
                                                {errors.email && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .email
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <a
                                                    onClick={() => {
                                                        navigation('/login')
                                                    }}
                                                    className="text-body">
                                                    Login with another email
                                                </a>
                                            </div>
                                            <div className="text-center text-lg-start mt-4 pt-2">
                                                <button type="submit" className="btn btn-primary w-100">
                                                    Submit
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )

}

export default ForgotPassword;